// extracted by mini-css-extract-plugin
module.exports = {"paymentOptions":"payment-switcher_paymentOptions__sBzwj","active":"payment-switcher_active__-ahh-"};